import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";
import { objectToQueryParams } from "@src/helper/objectToQueryParams";

const api = apiInstance()

export const getArticleBanner = async () => {
  return api.get(`/${PUBLIC_V1}/article_banner`)
}

export const getArticleDetail = async (id) => {
  return api.get(`/${PUBLIC_V1}/article/${id}`)
}

export const getArticleList = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/article${newParams ? `?${newParams}` : ""}`)
}

export const getArticleMore = async (id) => {
  return api.get(`/${PUBLIC_V1}/article_more/${id}`)
}

export const getArticleCategory = async () => {
  return api.get(`/${PUBLIC_V1}/article_category`)
}

export const postArticleCountViews = async (id) => {
  return api.post(`/${PUBLIC_V1}/article_count_views/${id}`)
}
